<script setup lang="ts">
import { defineProps, defineEmits } from 'vue';

defineProps({
  show: { type: Boolean, default: false },
  title: { type: String, default: '' },
  size: { type: String, default: 'max-w-md' }, // can be max-w-lg, max-w-xl etc.
});
defineEmits(['close']);
</script>

<template>
  <transition name="fade">
    <div v-if="show" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" @click="$emit('close')" @keyup.enter="$emit('close')" tabindex="0">
      <div class="bg-white rounded-md shadow-xl w-full p-4" :class="size" @click.stop>
        <div class="flex justify-between items-center mb-4">
          <h2 class="text-xl font-bold">{{ title }}</h2>
          <button type="button" @click="$emit('close')" class="text-gray-500 hover:text-gray-700">
            ✕
          </button>
        </div>
        <div class="mb-4">
          <slot />
        </div>
      </div>
    </div>
  </transition>
</template>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
